import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Divider,
    Paper
} from '@mui/material';

const TemplatePreviewModal = ({ open, onClose, template }) => {
    if (!template) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold' }}>
                Template Preview: {template.name}
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                        SUBJECT LINE
                    </Typography>
                    <Paper variant="outlined" sx={{ p: 2, mt: 1, bgcolor: 'rgba(0,0,0,0.01)', borderRadius: 2 }}>
                        <Typography variant="body1">{template.subject}</Typography>
                    </Paper>
                </Box>

                <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
                        MESSAGE BODY
                    </Typography>
                    <Paper 
                        variant="outlined" 
                        sx={{ 
                            p: 3, 
                            mt: 1, 
                            minHeight: 300, 
                            bgcolor: 'white', 
                            borderRadius: 2,
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'inherit'
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: template.body || template.message || '' }} />
                    </Paper>
                </Box>

                {template.isSystem && (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="caption" color="primary" sx={{ fontStyle: 'italic' }}>
                            * This is a system-protected template. Variables like {"{{guest_name}}"} will be dynamically populated during delivery.
                        </Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ p: 2.5 }}>
                <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }}>Close Preview</Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplatePreviewModal;
